// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1tLMQ","question":"Question_question__u9rSW","description":"Question_description__cYdkR"};